import React from 'react';
import {useTranslation} from 'react-i18next';
import {useAppSelector} from 'hooks';
import {UPLOAD_PHOTO_STATES} from '../constants';
import Button from 'components/common/Button';
import {ButtonsWrapper} from './styled';

type ButtonsProps = {
  state: UPLOAD_PHOTO_STATES;
  onChange?: () => void;
  onCapture?: () => void;
  onFinishUploadPhoto?: () => void;
  disabled?: boolean;
};
const Buttons = ({
  state,
  onChange,
  onCapture,
  onFinishUploadPhoto,
  disabled,
}: ButtonsProps) => {
  const uploadedImage = useAppSelector(state => state.photoBox.uploadedImage);
  const {t} = useTranslation();

  const getButtons = React.useCallback(() => {
    switch (state) {
      case UPLOAD_PHOTO_STATES.take:
        return (
          <Button
            label={t('take_photo')}
            disabled={disabled}
            onClick={onCapture}
            outlined
          />
        );
      case UPLOAD_PHOTO_STATES.scan:
        return (
          <Button label={t('scan_document')} disabled={disabled} onClick={onCapture} />
        );
      case UPLOAD_PHOTO_STATES.upload:
        return (
          <>
            <Button
              label={t('confirm')}
              onClick={onFinishUploadPhoto}
              disabled={disabled || !uploadedImage}
            />
            <Button
              label={t('change_photo')}
              disabled={disabled || !uploadedImage}
              onClick={onChange}
              link
            />
          </>
        );
    }
  }, [state, t, onCapture, onFinishUploadPhoto, disabled, onChange, uploadedImage]);

  return <ButtonsWrapper className="photo-box__btns">{getButtons()}</ButtonsWrapper>;
};

export {Buttons};
